import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler, showSuccess, showToastError } from 'utils';

import placeApi from 'api/placeApi';
import {
  // GET GLOBAL PLACES
  GET_GLOBAL_PLACES,
  GET_GLOBAL_PLACES_SUCCESS,
  GET_GLOBAL_PLACES_FAILED,

  // GET MY PLACE
  GET_MY_PLACE,
  GET_MY_PLACE_SUCCESS,
  GET_MY_PLACE_FAILED,

  // GET PLACE TODAY BOOKING
  GET_PLACE_TODAY_BOOKING,
  GET_PLACE_TODAY_BOOKING_SUCCESS,
  GET_PLACE_TODAY_BOOKING_FAILED,

  // GET PLACE DETAIL
  GET_PLACE_DETAIL,
  GET_PLACE_DETAIL_SUCCESS,
  GET_PLACE_DETAIL_FAILED,

  // UPDATE PLACE
  UPDATE_PLACE,
  UPDATE_PLACE_SUCCESS,
  UPDATE_PLACE_FAILED,

  // GET PLACE IMAGES
  GET_PLACE_IMAGES,
  GET_PLACE_IMAGES_SUCCESS,
  GET_PLACE_IMAGES_FAILED,

  // POST PLACE PREVIEW IMAGE
  POST_PLACE_PREVIEW_IMAGE,
  POST_PLACE_PREVIEW_IMAGE_SUCCESS,
  POST_PLACE_PREVIEW_IMAGE_FAILED,

  // POST PLACE IMAGES
  POST_PLACE_IMAGES,
  POST_PLACE_IMAGES_SUCCESS,
  POST_PLACE_IMAGES_FAILED,

  // DELETE PLACE IMAGES
  DELETE_PLACE_IMAGES,
  DELETE_PLACE_IMAGES_SUCCESS,
  DELETE_PLACE_IMAGES_FAILED,

  // POST IMAGES FROM PLACE TO ROOMS
  POST_IMAGES_FROM_PLACE_TO_ROOMS,
  POST_IMAGES_FROM_PLACE_TO_ROOMS_SUCCESS,
  POST_IMAGES_FROM_PLACE_TO_ROOMS_FAILED,

  // CHANGE POSITION PLACE IMAGES
  CHANGE_POSITION_PLACE_IMAGES,
  CHANGE_POSITION_PLACE_IMAGES_SUCCESS,
  CHANGE_POSITION_PLACE_IMAGES_FAILED,

  // DELETE IMAGES ROOMS FROM PLACE
  DELETE_IMAGES_ROOMS_FROM_PLACE,
  DELETE_IMAGES_ROOMS_FROM_PLACE_SUCCESS,
  DELETE_IMAGES_ROOMS_FROM_PLACE_FAILED,

  // PUT PLACE SERVICES EDIT
  EDIT_PLACE_SERVICES,
  EDIT_PLACE_SERVICES_SUCCESS,
  EDIT_PLACE_SERVICES_FAILED,

  // EDIT PLACE PARKING SERVICE
  EDIT_PLACE_PARKING_SERVICE,
  EDIT_PLACE_PARKING_SERVICE_SUCCESS,
  EDIT_PLACE_PARKING_SERVICE_FAILED,

  // EDIT CANCEL POLICY
  EDIT_CANCEL_POLICY,
  EDIT_CANCEL_POLICY_SUCCESS,
  EDIT_CANCEL_POLICY_FAILED,

  // UPDATE PLACE SERVICE FEE
  UPDATE_PLACE_SERVICE_FEE,
  UPDATE_PLACE_SERVICE_FEE_SUCCESS,
  UPDATE_PLACE_SERVICE_FEE_FAILED,

  // ADD PLACE OTHER FEE
  ADD_PLACE_OTHER_FEE,
  ADD_PLACE_OTHER_FEE_SUCCESS,
  ADD_PLACE_OTHER_FEE_FAILED,

  // UPDATE PLACE OTHER FEE
  UPDATE_PLACE_OTHER_FEE,
  UPDATE_PLACE_OTHER_FEE_SUCCESS,
  UPDATE_PLACE_OTHER_FEE_FAILED,

  // DELETE PLACE OTHER FEE
  DELETE_PLACE_OTHER_FEE,
  DELETE_PLACE_OTHER_FEE_SUCCESS,
  DELETE_PLACE_OTHER_FEE_FAILED,

  // EDIT POLICY RECEIVE ROOM
  EDIT_POLICY_RECEIVE_ROOM,
  EDIT_POLICY_RECEIVE_ROOM_SUCCESS,
  EDIT_POLICY_RECEIVE_ROOM_FAILED,

  // EDIT POLICY DEPOSIT
  EDIT_POLICY_DEPOSIT,
  EDIT_POLICY_DEPOSIT_SUCCESS,
  EDIT_POLICY_DEPOSIT_FAILED,

  // EDIT POLICY SMOKE AND PET
  EDIT_POLICY_SMOKE_AND_PET,
  EDIT_POLICY_SMOKE_AND_PET_SUCCESS,
  EDIT_POLICY_SMOKE_AND_PET_FAILED,

  // EDIT POLICY CURFEW
  EDIT_POLICY_CURFEW,
  EDIT_POLICY_CURFEW_SUCCESS,
  EDIT_POLICY_CURFEW_FAILED,

  // EDIT OTHER POLICY
  EDIT_OTHER_POLICY,
  EDIT_OTHER_POLICY_SUCCESS,
  EDIT_OTHER_POLICY_FAILED,

  // GET LIST ROOM OF PLACE
  GET_LIST_ROOM_OF_PLACE,
  GET_LIST_ROOM_OF_PLACE_SUCCESS,
  GET_LIST_ROOM_OF_PLACE_FAILED,

  // GET ROOM FACILITIES
  GET_ROOM_FACILITIES,
  GET_ROOM_FACILITIES_SUCCESS,
  GET_ROOM_FACILITIES_FAILED,

  // ADD ROOM FACILITIES
  ADD_ROOM_FACILITIES,
  ADD_ROOM_FACILITIES_SUCCESS,
  ADD_ROOM_FACILITIES_FAILED,

  // CREATE NEW PLACE
  CREATE_NEW_PLACE,
  CREATE_NEW_PLACE_SUCCESS,
  CREATE_NEW_PLACE_FAILED,

  // UPDATE NUMBER AVAILABLE ROOM
  UPDATE_NUMBER_AVAILABLE_ROOM,
  UPDATE_NUMBER_AVAILABLE_ROOM_SUCCESS,
  UPDATE_NUMBER_AVAILABLE_ROOM_FAILED,

  // ADD IMAGE TO PLACE PUBLIC IMAGES
  ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES,
  ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_SUCCESS,
  ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_FAILED,

  // DELETE IMAGE FROM PLACE PUBLIC IMAGES
  DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES,
  DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_SUCCESS,
  DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_FAILED,

  // UPDATE PLACE VIDEO
  UPDATE_PLACE_VIDEO,
  UPDATE_PLACE_VIDEO_SUCCESS,
  UPDATE_PLACE_VIDEO_FAILED,

  // DELETE PLACE VIDEO
  DELETE_PLACE_VIDEO,
  DELETE_PLACE_VIDEO_SUCCESS,
  DELETE_PLACE_VIDEO_FAILED,

  // UPDATE CLOSE OPEN ROOM
  UPDATE_CLOSE_OPEN_ROOM,
  UPDATE_CLOSE_OPEN_ROOM_SUCCESS,
  UPDATE_CLOSE_OPEN_ROOM_FAILED,

  // UPDATE PRICE ROOM
  UPDATE_PRICE_ROOM,
  UPDATE_PRICE_ROOM_SUCCESS,
  UPDATE_PRICE_ROOM_FAILED,

  // GET PLACE PRICE TYPES
  GET_PLACE_PRICE_TYPES,
  GET_PLACE_PRICE_TYPES_SUCCESS,
  GET_PLACE_PRICE_TYPES_FAILED,

  // ADD PLACE PRICE TYPES
  ADD_PLACE_PRICE_TYPES,
  ADD_PLACE_PRICE_TYPES_SUCCESS,
  ADD_PLACE_PRICE_TYPES_FAILED,

  // DELETE PLACE PRICE TYPES
  DELETE_PLACE_PRICE_TYPES,
  DELETE_PLACE_PRICE_TYPES_SUCCESS,
  DELETE_PLACE_PRICE_TYPES_FAILED,

  // EDIT PLACE PRICE TYPES
  EDIT_PLACE_PRICE_TYPES,
  EDIT_PLACE_PRICE_TYPES_SUCCESS,
  EDIT_PLACE_PRICE_TYPES_FAILED,

  // UPDATE CHILDREN AND EXTRA BED POLICY
  UPDATE_CHILDREN_AND_EXTRA_BED_POLICY,
  UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_SUCCESS,
  UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_FAILED,

  // UPLOAD PLACE CONTRACT
  UPLOAD_PLACE_CONTRACT,
  UPLOAD_PLACE_CONTRACT_SUCCESS,
  UPLOAD_PLACE_CONTRACT_FAILED,

  // ADD PLACE FAVORITE
  ADD_PLACE_FAVORITE,
  ADD_PLACE_FAVORITE_SUCCESS,
  ADD_PLACE_FAVORITE_FAILED,

  // DELETE PLACE FAVORITE
  DELETE_PLACE_FAVORITE,
  DELETE_PLACE_FAVORITE_SUCCESS,
  DELETE_PLACE_FAVORITE_FAILED,
} from 'store/place/actionTypes';
import { GET_ROOM_IMAGES } from 'store/room/actionTypes';
import { RESET_FORM_SUCCESS } from 'store/edit-location/actionTypes';

function* getGlobalPlaces({ payload }) {
  try {
    const response = yield placeApi.getGlobalPlaces(payload);

    yield put({
      type: GET_GLOBAL_PLACES_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_GLOBAL_PLACES_FAILED,
    });
  }
}

function* getMyPlace({ payload }) {
  try {
    const response = payload?.isIntranet
      ? yield placeApi.getIntranetPlaces(payload)
      : yield placeApi.getMyPlace(payload);

    yield put({
      type: GET_MY_PLACE_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_MY_PLACE_FAILED,
    });
  }
}

function* getPlaceTodayBooking({ payload }) {
  const { placeId } = payload;

  try {
    const response = yield placeApi.getPlaceTodayBooking({ placeId });

    yield put({
      type: GET_PLACE_TODAY_BOOKING_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_PLACE_TODAY_BOOKING_FAILED,
    });
  }
}

function* getPlaceDetail({ payload }) {
  try {
    const response = yield placeApi.getPlaceDetail(payload);

    yield put({
      type: GET_PLACE_DETAIL_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_PLACE_DETAIL_FAILED,
    });
  }
}

function* updatePlace({ payload }) {
  try {
    const { callback } = payload;
    const response = yield placeApi.updatePlace(payload);

    yield put({
      type: UPDATE_PLACE_SUCCESS,
      payload: response.payload,
    });

    callback();
    showSuccess('Chỉnh sửa chỗ nghỉ thành công!');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_PLACE_FAILED,
    });
  }
}

function* getPlaceImages({ payload }) {
  try {
    const response = yield placeApi.getPlaceImages(payload);

    yield put({
      type: GET_PLACE_IMAGES_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_PLACE_IMAGES_FAILED,
    });
  }
}

function* updatePlacePreviewImage({ payload }) {
  const { placeId } = payload;
  try {
    yield placeApi.updatePreviewImage(payload);
    yield put({
      type: POST_PLACE_PREVIEW_IMAGE_SUCCESS,
    });

    yield put({
      type: GET_PLACE_DETAIL,
      payload: {
        placeId,
      },
    });

    showSuccess('Thay đổi ảnh đại diện cho chỗ nghỉ thành công!');
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: POST_PLACE_PREVIEW_IMAGE_FAILED,
    });
  }
}

function* postPlaceImages({ payload }) {
  const { placeId } = payload;
  try {
    yield placeApi.postPlaceImages(payload);
    yield put({
      type: POST_PLACE_IMAGES_SUCCESS,
    });

    yield put({
      type: GET_PLACE_IMAGES,
      payload: {
        placeId,
      },
    });

    showSuccess('Thêm ảnh thành công!');
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: POST_PLACE_IMAGES_FAILED,
    });
  }
}

function* deletePlaceImages({ payload }) {
  const { placeId, images, callback } = payload;

  try {
    yield placeApi.deletePlaceImages({ placeId, images });
    yield put({
      type: DELETE_PLACE_IMAGES_SUCCESS,
    });

    yield put({
      type: GET_ROOM_IMAGES,
      payload: {
        placeId,
      },
    });

    showSuccess('Xóa hình ảnh thành công');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_PLACE_IMAGES_FAILED,
    });
  }
}

function* postImagesFromPlaceToRoom({ payload }) {
  const {
    placeId, images, roomIds, callback,
  } = payload;

  try {
    yield placeApi.postImagesFromPlaceToRoom({ placeId, images, roomIds });
    yield put({
      type: POST_IMAGES_FROM_PLACE_TO_ROOMS_SUCCESS,
    });

    yield put({
      type: GET_ROOM_IMAGES,
      payload: {
        placeId,
      },
    });

    showSuccess('Thêm ảnh vào phòng thành công!');

    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: POST_IMAGES_FROM_PLACE_TO_ROOMS_FAILED,
    });
  }
}

function* changePositionPlaceImages({ payload }) {
  const { placeId, images } = payload;
  try {
    yield placeApi.changePositionPlaceImages({ placeId, images });

    yield put({
      type: CHANGE_POSITION_PLACE_IMAGES_SUCCESS,
    });

    showSuccess('Thay đổi thứ tự ảnh thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: CHANGE_POSITION_PLACE_IMAGES_FAILED,
    });
    showToastError('Thay đổi thứ tự ảnh không thành công');
  }
}

function* deleteImagesRoomsFromPlace({ payload }) {
  const { placeId, callback } = payload;
  try {
    yield placeApi.deleteImagesRoomsFromPlace(payload);
    yield put({
      type: DELETE_IMAGES_ROOMS_FROM_PLACE_SUCCESS,
    });

    yield put({
      type: GET_ROOM_IMAGES,
      payload: {
        placeId,
      },
    });
    showSuccess('Xóa hình ảnh thành công');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_IMAGES_ROOMS_FROM_PLACE_FAILED,
    });
  }
}

function* editPlaceServices({ payload }) {
  const { placeId, callback, values } = payload;

  try {
    yield placeApi.editPlaceServices({ placeId, values });

    yield put({
      type: EDIT_PLACE_SERVICES_SUCCESS,
    });

    showSuccess('Cập nhật Tiện nghi và dịch vụ thành công');

    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: EDIT_PLACE_SERVICES_FAILED,
    });
  }
}

function* editPlaceParkingService({ payload }) {
  const { placeId, callback, values } = payload;

  try {
    yield placeApi.editPlaceParkingService({ placeId, values });

    yield put({
      type: EDIT_PLACE_PARKING_SERVICE_SUCCESS,
    });

    showSuccess('Cập nhật dịch vụ đậu xe thành công');

    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: EDIT_PLACE_PARKING_SERVICE_FAILED,
    });
  }
}

function* updatePlaceServiceFee({ payload }) {
  const { placeId, value, startAt, onCallBackSave, callback } = payload;
  try {
    yield placeApi.updatePlaceServiceFee({ placeId, value, startAt });

    yield put({
      type: UPDATE_PLACE_SERVICE_FEE_SUCCESS,
    });

    showSuccess('Cập nhật phí dịch vụ thành công');

    if (onCallBackSave) {
      onCallBackSave();
    }
    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_PLACE_SERVICE_FEE_FAILED,
    });
  }
}

function* addPlaceOtherFee({ payload }) {
  const { onCallBackSave, callback, ...restPayload } = payload;
  try {
    const response = yield placeApi.addPlaceOtherFee(restPayload);

    yield put({
      type: ADD_PLACE_OTHER_FEE_SUCCESS,
      payload: response,
    });

    showSuccess('Thêm phí thành công');

    if (onCallBackSave) {
      onCallBackSave();
    }
    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: ADD_PLACE_OTHER_FEE_FAILED,
    });
  }
}

function* updatePlaceOtherFee({ payload }) {
  const { onCallBackSave, callback, ...restPayload } = payload;
  try {
    const response = yield placeApi.updatePlaceOtherFee(restPayload);

    yield put({
      type: UPDATE_PLACE_OTHER_FEE_SUCCESS,
      payload: response,
    });

    showSuccess('Cập nhật phí thành công');

    if (onCallBackSave) {
      onCallBackSave();
    }
    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_PLACE_OTHER_FEE_FAILED,
    });
  }
}

function* deletePlaceOtherFee({ payload }) {
  const { onCallBackSave, callback, ...restPayload } = payload;
  try {
    const response = yield placeApi.deletePlaceOtherFee(restPayload);

    yield put({
      type: DELETE_PLACE_OTHER_FEE_SUCCESS,
      payload: response,
    });

    showSuccess('Xoá phí thành công');

    if (onCallBackSave) {
      onCallBackSave();
    }
    if (callback) {
      callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: DELETE_PLACE_OTHER_FEE_FAILED,
    });
  }
}

function* editCancelPolicy({ payload }) {
  try {
    yield placeApi.editCancelPolicy(payload);

    yield put({
      type: EDIT_CANCEL_POLICY_SUCCESS,
    });

    showSuccess('Cập nhật chính sách hủy phòng thành công');
    payload.onCallBackSave();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: EDIT_CANCEL_POLICY_FAILED,
    });
  }
}

function* editReceiveRoomPolicy({ payload }) {
  try {
    yield placeApi.editReceiveRoomPolicy(payload);

    yield put({
      type: EDIT_POLICY_RECEIVE_ROOM_SUCCESS,
    });

    showSuccess('Cập nhật chính sách nhận phòng thành công');
    payload.onCallBackSave();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: EDIT_POLICY_RECEIVE_ROOM_FAILED,
    });
  }
}

function* editDepositPolicy({ payload }) {
  try {
    yield placeApi.editDepositPolicy(payload);

    yield put({
      type: EDIT_POLICY_DEPOSIT_SUCCESS,
    });

    showSuccess('Cập nhật chính sách thanh toán thành công');
    payload.onCallBackSave();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: EDIT_POLICY_DEPOSIT_FAILED,
    });
  }
}

function* editSmokeAndPetPolicy({ payload }) {
  try {
    yield placeApi.editSmokeAndPetPolicy(payload);

    yield put({
      type: EDIT_POLICY_SMOKE_AND_PET_SUCCESS,
    });

    showSuccess('Cập nhật chính sách hút thuốc và thú cưng thành công');
    payload.onCallBackSave();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: EDIT_POLICY_SMOKE_AND_PET_FAILED,
    });
  }
}

function* editCurfewPolicy({ payload }) {
  try {
    yield placeApi.editCurfewPolicy(payload);

    yield put({
      type: EDIT_POLICY_CURFEW_SUCCESS,
    });

    showSuccess('Cập nhật chính sách giờ giới nghiêm thành công');
    if (payload?.onCallBackSave && typeof payload.onCallBackSave === 'function') {
      payload.onCallBackSave();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: EDIT_POLICY_CURFEW_FAILED,
    });
  }
}

function* editOtherPolicy({ payload }) {
  try {
    yield placeApi.editOtherPolicy(payload);

    yield put({
      type: EDIT_OTHER_POLICY_SUCCESS,
    });

    showSuccess('Cập nhật chính sách khác thành công');
    if (payload?.onCallBackSave && typeof payload.onCallBackSave === 'function') {
      payload.onCallBackSave();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: EDIT_OTHER_POLICY_FAILED,
    });
  }
}

function* getListRoomOfPlace({ payload }) {
  try {
    const response = yield placeApi.getListRoomOfPlace(payload);

    yield put({
      type: GET_LIST_ROOM_OF_PLACE_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_LIST_ROOM_OF_PLACE_FAILED,
    });
  }
}

function* GetRoomFacilities({ payload }) {
  try {
    const response = yield placeApi.getRoomFacilities(payload);

    yield put({
      type: GET_ROOM_FACILITIES_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_ROOM_FACILITIES_FAILED,
    });
  }
}

function* updateRoomFacilities({ payload }) {
  try {
    yield placeApi.updateRoomFacilities(payload);

    yield put({
      type: ADD_ROOM_FACILITIES_SUCCESS,
    });

    showSuccess('Cập nhật tiện nghi phòng thành công');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: ADD_ROOM_FACILITIES_FAILED,
    });
  }
}

function* createNewPlace({ payload }) {
  const { location, callback } = payload;
  try {
    yield placeApi.createNewPlace(location);

    yield put({
      type: CREATE_NEW_PLACE_SUCCESS,
    });

    yield put({
      type: RESET_FORM_SUCCESS,
    });

    callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: CREATE_NEW_PLACE_FAILED,
    });
  }
}

function* updateAvailableRoom({ payload }) {
  try {
    yield placeApi.updateAvailableRoom(payload);

    yield put({
      type: UPDATE_NUMBER_AVAILABLE_ROOM_SUCCESS,
    });

    showSuccess('Cập nhật số lượng phòng thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: UPDATE_NUMBER_AVAILABLE_ROOM_FAILED,
    });
  }
}

function* addImageToPublicImages({ payload }) {
  try {
    const { placeId, callback } = payload;
    const response = yield placeApi.addImageToPublicImages(payload);

    yield put({
      type: ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_SUCCESS,
      payload: response.payload,
    });

    yield put({
      type: GET_PLACE_DETAIL,
      payload: {
        placeId,
      },
    });

    showSuccess('Thêm ảnh thành công!');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_FAILED,
    });
  }
}

function* updatePlaceVideo({ payload }) {
  try {
    const { placeId, callback } = payload;
    const response = yield placeApi.updatePlaceVideo(payload);

    yield put({
      type: UPDATE_PLACE_VIDEO_SUCCESS,
      payload: response.payload,
    });

    yield put({
      type: GET_PLACE_DETAIL,
      payload: {
        placeId,
      },
    });

    showSuccess('Thêm video thành công!');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: UPDATE_PLACE_VIDEO_FAILED,
    });
  }
}

function* deletePlaceVideo({ payload }) {
  try {
    const { placeId, callback } = payload;

    yield placeApi.deletePlaceVideo(payload);

    yield put({
      type: DELETE_PLACE_VIDEO_SUCCESS,
    });

    yield put({
      type: GET_PLACE_DETAIL,
      payload: {
        placeId,
      },
    });

    showSuccess('Xóa video thành công!');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_PLACE_VIDEO_FAILED,
    });
  }
}

function* deleteImageFromPublicImages({ payload }) {
  const { placeId, images, callback } = payload;

  try {
    yield placeApi.deleteImageFromPublicImages({ placeId, images });
    yield put({
      type: DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_SUCCESS,
    });

    yield put({
      type: GET_PLACE_DETAIL,
      payload: {
        placeId,
      },
    });

    showSuccess('Xóa hình ảnh thành công');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_FAILED,
    });
  }
}

function* updateCloseOpenRoom({ payload }) {
  try {
    yield placeApi.updateCloseOpenRoom(payload);

    yield put({
      type: UPDATE_CLOSE_OPEN_ROOM_SUCCESS,
    });

    showSuccess('Cập nhật tình trạng phòng thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: UPDATE_CLOSE_OPEN_ROOM_FAILED,
    });
  }
}

function* updatePriceRoom({ payload }) {
  const { data, placeId } = payload;
  try {
    yield placeApi.updatePriceRoom({
      placeId,
      data,
    });

    yield put({
      type: UPDATE_PRICE_ROOM_SUCCESS,
    });

    showSuccess('Cập nhật giá phòng thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: UPDATE_PRICE_ROOM_FAILED,
    });
  }
}

function* getPlacePriceTypes({ payload }) {
  try {
    const response = yield placeApi.getPlacePriceTypes(payload);

    yield put({
      type: GET_PLACE_PRICE_TYPES_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_PLACE_PRICE_TYPES_FAILED,
    });
  }
}

function* addPlacePriceTypes({ payload }) {
  try {
    yield placeApi.addPlacePriceTypes(payload);

    yield put({
      type: ADD_PLACE_PRICE_TYPES_SUCCESS,
    });

    payload.onCallBackSave();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: ADD_PLACE_PRICE_TYPES_FAILED,
    });
  }
}

function* deletePlacePriceTypes({ payload }) {
  try {
    yield placeApi.deletePlacePriceTypes(payload);

    yield put({
      type: DELETE_PLACE_PRICE_TYPES_SUCCESS,
    });
    showSuccess('Xóa loại giá thành công');
    payload.reloadPlacePriceTypesOnSave();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_PLACE_PRICE_TYPES_FAILED,
    });
  }
}

function* editPlacePriceTypes({ payload }) {
  try {
    yield placeApi.editPlacePriceTypes(payload);

    yield put({
      type: EDIT_PLACE_PRICE_TYPES_SUCCESS,
    });

    payload.onCallBackSave();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: EDIT_PLACE_PRICE_TYPES_FAILED,
    });
  }
}

function* updateChildrenAndExtraBedPolicy({ payload }) {
  try {
    yield placeApi.updateChildrenAndExtraBedPolicy(payload);

    yield put({
      type: UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_SUCCESS,
    });

    showSuccess('Cập nhật chính sách trẻ em và giường phụ thành công');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_FAILED,
    });
  }
}

function* uploadPlaceContract({ payload }) {
  const { placeId } = payload;

  try {
    yield placeApi.uploadPlaceContract(payload);

    yield put({
      type: UPLOAD_PLACE_CONTRACT_SUCCESS,
    });

    yield put({
      type: GET_PLACE_DETAIL,
      payload: {
        placeId,
      },
    });

    showSuccess('Tải lên hợp đồng thành công!');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPLOAD_PLACE_CONTRACT_FAILED,
    });
  }
}

function* addPlaceFavorite({ payload }) {
  const { placeId, callback } = payload || {};
  try {
    yield placeApi.addPlaceFavorite({ placeId });

    yield put({
      type: ADD_PLACE_FAVORITE_SUCCESS,
      payload: placeId,
    });

    callback?.();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: ADD_PLACE_FAVORITE_FAILED,
    });
  }
}

function* deletePlaceFavorite({ payload }) {
  const { placeId, callback } = payload || {};
  try {
    yield placeApi.deletePlaceFavorite({ placeId });

    yield put({
      type: DELETE_PLACE_FAVORITE_SUCCESS,
      payload: placeId,
    });

    callback?.();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: DELETE_PLACE_FAVORITE_FAILED,
    });
  }
}

export default function* locationSaga() {
  yield takeLeading(GET_GLOBAL_PLACES, getGlobalPlaces);
  yield takeLeading(GET_MY_PLACE, getMyPlace);
  yield takeLeading(GET_PLACE_TODAY_BOOKING, getPlaceTodayBooking);
  yield takeLeading(GET_PLACE_DETAIL, getPlaceDetail);
  yield takeLeading(UPDATE_PLACE, updatePlace);
  yield takeLeading(GET_PLACE_IMAGES, getPlaceImages);
  yield takeLeading(POST_PLACE_PREVIEW_IMAGE, updatePlacePreviewImage);
  yield takeLeading(POST_PLACE_IMAGES, postPlaceImages);
  yield takeLeading(DELETE_PLACE_IMAGES, deletePlaceImages);
  yield takeLeading(POST_IMAGES_FROM_PLACE_TO_ROOMS, postImagesFromPlaceToRoom);
  yield takeLeading(CHANGE_POSITION_PLACE_IMAGES, changePositionPlaceImages);
  yield takeLeading(DELETE_IMAGES_ROOMS_FROM_PLACE, deleteImagesRoomsFromPlace);
  yield takeLeading(EDIT_PLACE_SERVICES, editPlaceServices);
  yield takeLeading(EDIT_PLACE_PARKING_SERVICE, editPlaceParkingService);
  yield takeLeading(EDIT_CANCEL_POLICY, editCancelPolicy);
  yield takeLeading(UPDATE_PLACE_SERVICE_FEE, updatePlaceServiceFee);
  yield takeLeading(ADD_PLACE_OTHER_FEE, addPlaceOtherFee);
  yield takeLeading(UPDATE_PLACE_OTHER_FEE, updatePlaceOtherFee);
  yield takeLeading(DELETE_PLACE_OTHER_FEE, deletePlaceOtherFee);
  yield takeLeading(EDIT_POLICY_RECEIVE_ROOM, editReceiveRoomPolicy);
  yield takeLeading(EDIT_POLICY_DEPOSIT, editDepositPolicy);
  yield takeLeading(EDIT_POLICY_SMOKE_AND_PET, editSmokeAndPetPolicy);
  yield takeLeading(EDIT_POLICY_CURFEW, editCurfewPolicy);
  yield takeLeading(EDIT_OTHER_POLICY, editOtherPolicy);
  yield takeLeading(GET_LIST_ROOM_OF_PLACE, getListRoomOfPlace);
  yield takeLeading(GET_ROOM_FACILITIES, GetRoomFacilities);
  yield takeLeading(ADD_ROOM_FACILITIES, updateRoomFacilities);
  yield takeLeading(CREATE_NEW_PLACE, createNewPlace);
  yield takeLeading(UPDATE_NUMBER_AVAILABLE_ROOM, updateAvailableRoom);
  yield takeLeading(ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES, addImageToPublicImages);
  yield takeLeading(UPDATE_PLACE_VIDEO, updatePlaceVideo);
  yield takeLeading(DELETE_PLACE_VIDEO, deletePlaceVideo);
  yield takeLeading(DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES, deleteImageFromPublicImages);
  yield takeLeading(UPDATE_CLOSE_OPEN_ROOM, updateCloseOpenRoom);
  yield takeLeading(UPDATE_PRICE_ROOM, updatePriceRoom);
  yield takeLeading(GET_PLACE_PRICE_TYPES, getPlacePriceTypes);
  yield takeLeading(ADD_PLACE_PRICE_TYPES, addPlacePriceTypes);
  yield takeLeading(DELETE_PLACE_PRICE_TYPES, deletePlacePriceTypes);
  yield takeLeading(EDIT_PLACE_PRICE_TYPES, editPlacePriceTypes);
  yield takeLeading(UPDATE_CHILDREN_AND_EXTRA_BED_POLICY, updateChildrenAndExtraBedPolicy);
  yield takeLeading(UPLOAD_PLACE_CONTRACT, uploadPlaceContract);
  yield takeLeading(ADD_PLACE_FAVORITE, addPlaceFavorite);
  yield takeLeading(DELETE_PLACE_FAVORITE, deletePlaceFavorite);
}
